/**
 * Blocking Error Store
 * Manages critical errors that require user acknowledgment before continuing.
 * Used for validation failures, workflow-blocking errors, etc.
 */

import { create } from 'zustand';

interface BlockingErrorState {
  /** The error message to display, null if no blocking error */
  message: string | null;
  /** Title for the error modal */
  title: string;
  /** Show a blocking error modal */
  show: (message: string, title?: string) => void;
  /** Clear the blocking error and dismiss modal */
  clear: () => void;
}

export const useBlockingErrorStore = create<BlockingErrorState>((set) => ({
  message: null,
  title: 'Action Required',
  show: (message: string, title = 'Action Required') => set({ message, title }),
  clear: () => set({ message: null, title: 'Action Required' }),
}));

/**
 * Helper to show blocking error from outside React components
 * (e.g., from API interceptors)
 */
export const showBlockingError = (message: string, title?: string) => {
  useBlockingErrorStore.getState().show(message, title);
};

/**
 * Helper to clear blocking error from outside React components
 */
export const clearBlockingError = () => {
  useBlockingErrorStore.getState().clear();
};
